import { useQuery } from "@tanstack/react-query";
import API from "@/api";

function useObservation(nurseryId: string, observationId: string) {
  const { isPending, error, data } = useQuery({
    queryKey: ["observation", nurseryId, observationId],
    queryFn: () => API.getObservation(nurseryId, observationId)
  });

  return {
    isPending,
    error,
    data
  };
}

export default useObservation;
